/** Builds the v2-pipeline plan for pure reorder (no assign / unassign). */
import type {
  Deps,
  OperationPlan,
  PipelineStep,
  ResequenceIntent,
} from 'types/modules/routing'

import { makePreflightStep } from '../steps/preflight'
import { makeSequenceDailyStep } from '../steps/sequenceDaily'
import { makeSequenceMasterStep } from '../steps/sequenceMaster'
import { makeVerifyStep } from '../steps/verify'

const STRATEGY_ID = 'v2-pipeline' as const

export const buildResequencePipeline = (
  intent: ResequenceIntent,
  deps: Deps,
): OperationPlan => {
  const steps: PipelineStep[] = []
  const includeMaster = intent.includeMaster === true

  steps.push(makePreflightStep({ intent }, deps) as PipelineStep)

  if (intent.orderedStops.length > 0) {
    steps.push(
      makeSequenceDailyStep(
        {
          routeId: intent.routeId,
          serviceDate: intent.serviceDate,
          orderedStops: intent.orderedStops,
        },
        deps,
      ) as PipelineStep,
    )
  }

  if (
    includeMaster &&
    intent.masterDayOfWeek &&
    intent.masterOrderedStops &&
    intent.masterOrderedStops.length > 0
  ) {
    steps.push(
      makeSequenceMasterStep(
        {
          routeId: intent.routeId,
          dayOfWeek: intent.masterDayOfWeek,
          orderedStops: intent.masterOrderedStops,
        },
        deps,
      ) as PipelineStep,
    )
  }

  steps.push(
    makeVerifyStep(
      {
        intent,
        expectedFinalCount: intent.orderedStops.length,
      },
      deps,
    ) as PipelineStep,
  )

  return {
    strategy: STRATEGY_ID,
    intent,
    steps,
  }
}
